import { render, staticRenderFns } from "./FunnelChart1.vue?vue&type=template&id=f6ef9b22&scoped=true&"
import script from "./FunnelChart1.vue?vue&type=script&lang=js&"
export * from "./FunnelChart1.vue?vue&type=script&lang=js&"
import style0 from "./FunnelChart1.vue?vue&type=style&index=0&id=f6ef9b22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ef9b22",
  null
  
)

export default component.exports